"use client";
import React, {
  Context,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { Step } from "../FormStepper";
import ApiHelperFunction from "../../api";
import ApplyDetail from "../../components/itin/ApplyDetail";
import { Box } from "@mui/system";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import { useLocation, useParams } from "react-router";
import { CircularProgress } from "@mui/material";

interface StepperState {
  currentStepIdx: number;
  obstacle: boolean;
  setActiveStep?: (stepIdx: number, goingForward?: boolean) => void;
  data: Map<number, any>;
  stepsCompleted: Set<number>;
  steps: Step[];
  extras?: Map<string, any>;
  setLoading?: (loading: boolean) => void;
  setData?: (stepIdx: number, data: any, hardReset: boolean) => void;
  setExtra?: (key: string, value: any) => void;
  setStepCompleted?: (stepIdx: number) => void;
  updateSubStep?: (stepIdx: number, data: any) => void;
  setSteps?: (steps: Step[]) => void;
  loading?: boolean;
}

export const StepperContext: Context<StepperState> =
  createContext<StepperState>({
    currentStepIdx: 0,
    obstacle: false,
    data: new Map(),
    stepsCompleted: new Set<number>(),
    steps: [],
    loading: false,
  });

export const StepperProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("user_token");
  const [currentStepIdx, setCurrentStepIdx] = useState<number>(0);
  const location = useLocation();
  const isEditPassport = location.pathname.includes("edit-documents");
  const isEditW7 = location.pathname.includes("edit-w7");
  const { id } = useParams<{ id: string }>();
  const [itinStep, setItinStep] = useState<number | null>(0);
  const [getLoading, setGetLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setGetLoading(true);

    try {
      const response = await ApiHelperFunction({
        url: `/get-itin-data/?order_id=${id}`,
        method: "GET",
        headers: {
          Authorization: token ? `${token}` : "",
        },
      });

      if (isEditPassport) {
        setCurrentStepIdx(1);
        setItinStep(1);
      } else if (isEditW7) {
        setCurrentStepIdx(2);
        setItinStep(2);
      } else if (response?.data?.status && response?.data?.data) {
        const apiStep = response.data.data.itin_applications_step;
        setItinStep(apiStep);
        setCurrentStepIdx(apiStep);
      } else {
        setCurrentStepIdx(0);
      }

      setGetLoading(false);
    } catch (error) {
      setGetLoading(false);
    }
  };

  const [obstacle] = useState<boolean>(false);
  const [data, setDataState] = useState<Map<number, any[]>>(new Map());
  const [steps, setSteps] = useState<Step[]>([]);
  const [extras, setExtras] = useState<Map<string, any>>(new Map());
  const [stepsCompleted, setStepsCompleted] = useState<Set<number>>(new Set());

  const handleStepData = (stepIdx: number, data: any, hardReset: boolean) => {
    setDataState((prevState) => {
      const newState = new Map(prevState);

      if (newState.has(stepIdx)) {
        if (hardReset) newState.set(stepIdx, { ...data });
        else newState.set(stepIdx, { ...data });
      } else newState.set(stepIdx, data);
      return newState;
    });
  };

  const onSetStep = (stepIdx: number, goingForward?: boolean) => {
    const subStep = steps[stepIdx];
    console.log("setting step", stepIdx);
    setCurrentStepIdx(stepIdx);
    if (subStep?.skip) {
      let _stepIdx = stepIdx;
      if (goingForward && _stepIdx + 1 >= steps.length) {
        _stepIdx++;
      }
      if (goingForward == false && stepIdx - 1 == -1) {
        //
      }
      onSetStep(stepIdx + (goingForward ? 1 : -1), goingForward);
    } else {
      setCurrentStepIdx(stepIdx);
    }
  };

  const updateSubStep = (stepIdx: number, data: Step) => {
    console.log("Updating step: ", stepIdx);
    setSteps((prevState) => {
      const steps = [...prevState];
      steps[stepIdx] = { ...steps[stepIdx], ...data };
      return steps;
    });
  };

  const setStepCompleted = (idx: number) => {
    setStepsCompleted((prevState) => {
      const _completedSteps = new Set<number>(prevState);
      _completedSteps.add(idx);
      return _completedSteps;
    });
  };

  const setExtra = (key: string, value: any) => {
    setExtras((prevState) => {
      const _extras = new Map(prevState);
      _extras?.set(key, value);
      return _extras;
    });
  };

  if (getLoading) {
    return (
      // <Box
      //      sx={{
      //        display: "flex",
      //        alignItems: "center",
      //        justifyContent: "center",
      //        height: "100vh",
      //      }}
      //    >
      //      <CircularProgress />
      //    </Box>
      <ListLoadingNew />
    );
  }

  return (
    <StepperContext.Provider
      value={{
        currentStepIdx,
        obstacle,
        extras: extras,
        stepsCompleted: stepsCompleted,
        setActiveStep: onSetStep,
        steps: steps,
        data: data,
        setLoading: setIsLoading,
        setExtra: setExtra,
        loading: isLoading,
        updateSubStep: updateSubStep,
        setStepCompleted: setStepCompleted,
        setData: handleStepData,
        setSteps: setSteps,
      }}
    >
      {itinStep === 4 ? <ApplyDetail /> : children}
    </StepperContext.Provider>
  );
};
